// Textos del detalle de cobros, sus estados y mensajes de ayuda.
export const DAILY_CHARGES_TEXT = {
  ARIA_LABEL: 'Detalle de cobros',
  TABLE_ARIA_LABEL: 'Cobros del usuario',
  EMPTY: 'Sin cobros disponibles para este usuario',
  MULTIPLE_METHODS: (count) => `Varios tipos (${count})`,
  MISSING_VALUE: '-',
  PENDING: 'Pendiente',
  UNSETTLED_SUFFIX: ' sin liquidar',
  SUMMARY: (settled, total, amount) =>
    `${settled} de ${total} cobros liquidados: ${amount} cobrados`
}

// Ancho mínimo de la tabla y formatos de hora y fecha de los cobros.
export const DAILY_CHARGES_CONFIG = {
  MIN_WIDTH: 1100,
  ROW_KEY: 'charge_uid',
  TIME_FORMAT: 'hh:mm A',
  SETTLED_AT_FORMAT: 'D MMM - hh:mm A'
}

// Estilo compartido para alinear visualmente horas, tiempos y montos.
export const DAILY_CHARGES_NUMERIC_CELL_SX = {
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums'
}

// El componente agrega los renderizados que dependen de los datos.
export const DAILY_CHARGES_COLUMNS = [
  { key: 'charge_uid', label: 'Recibo', width: '16%' },
  { key: 'client_name', label: 'Cliente', width: '20%', truncate: true },
  { key: 'payment_method', label: 'Método', width: '10%' },
  {
    key: 'charged_at',
    label: 'Hora cobro',
    width: '12%',
    cellSx: DAILY_CHARGES_NUMERIC_CELL_SX
  },
  {
    key: 'settled_at',
    label: 'Liquidación',
    width: '16%',
    cellSx: DAILY_CHARGES_NUMERIC_CELL_SX
  },
  {
    key: 'elapsed_seconds',
    label: 'Tiempo',
    width: '16%',
    cellSx: DAILY_CHARGES_NUMERIC_CELL_SX
  },
  {
    key: 'amount',
    label: 'Monto',
    width: '10%',
    align: 'right',
    cellSx: DAILY_CHARGES_NUMERIC_CELL_SX
  }
]
